import "./BradfordWhiteWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import BradfordWhite from "./sections/BradfordWhite";
import BradfordWhiteServices from "./sections/BradfordWhiteServices";
import BradfordTrust from "./sections/BradfordTrust";
import Footer from "@/reusable_sections/Footer";
export default function BradfordWhiteWaterHeaterServicePage() {
  return <div>
      <Header />
      <BradfordWhite />
      <BradfordWhiteServices />
      <BradfordTrust />
      <Footer />
    </div>;
}